import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box } from '@material-ui/core';

import { useStyles, customCardStyles } from './SKUsAssociated.styled';
import i18n from 'i18n-js';
import { Card } from 'components/UI';
import { Table } from 'components/UI';
import { withRouter } from 'react-router-dom';
import { PricingActions } from 'state/modules/pricing';
import { DatetimeField } from 'components/DatetimeField';

const SKUsAssociated = ({ id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const cardClasses = customCardStyles();
  const [params, setParams] = useState({
    limit: 5,
    page: 1,
  });
  const { localeFormat } = useSelector((state) => state.organizations);

  const {
    skusAssociated: { list, loading, pagination },
  } = useSelector((state) => state.pricing);

  /**
   * Table columns
   * Show or hide columns with omit key
   */
  const columns = [
    {
      name: i18n.t('common.id'),
      selector: 'id',
      grow: 0,
      minWidth: '4rem',
    },
    {
      name: i18n.t('tax_ruleset.sku'),
      selector: 'name',
      cell: (row) => row?.name,
      minWidth: '10rem',
    },
    {
      name: i18n.t('common.start_date'),
      selector: 'start_time',
      cell: (row) => <DatetimeField datetime={row?.start_time} />,
      grow: 1,
      minWidth: '10rem',
    },
    {
      name: i18n.t('common.end_date'),
      selector: 'end_time',
      cell: (row) => <DatetimeField datetime={row?.end_time} />,
      grow: 1,
      minWidth: '10rem',
    },
  ];

  /**
   * Get vehicles grpups list
   * @param {object} params Request params
   */
  const fetchSKUsAssociated = useCallback(
    (id) => {
      dispatch(PricingActions.fetchSKUsAssociated(id, params));
    },
    [dispatch, params]
  );

  useEffect(() => {
    if (id) {
      fetchSKUsAssociated(id);
    }
  }, [fetchSKUsAssociated, id]);

  /**
   * Handle page change on table
   * @param {number} page Number of the page
   */
  const handlePageChange = (page) => {
    const newParams = { page, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  return (
    <Card
      menuItems={[]}
      headerActionType="vertical"
      contentRootClasses={cardClasses}
      data-cy="associated-skus-widget-card"
      title={i18n.t('tax_ruleset.sku_associated')}
    >
      <Box className={classes.cardContentPadding}>
        <Table
          data={list}
          columns={columns}
          loading={loading}
          handlePageChange={handlePageChange}
          paginationPerPage={params?.limit || 0}
          totalRows={pagination?.totalRows || 0}
          paginationComponentOptions={{ noRowsPerPage: true }}
        />
      </Box>
    </Card>
  );
};

export default withRouter(SKUsAssociated);
